<template>
  <div class="quiz-dialog">
    <div class="box">
      <div class="close-btn" @click="$emit('closeDialog')">
        <div class="shadow"></div>
      </div>
      
      <div class="topic">開始小測喇！</div>
      <div class="area">
        <div class="problem">
          <div class="title">這個小測涵蓋的課题有:</div>
          <ul class="list">
            <li class="single" v-for="(its, idx) in list" :key="idx">{{ its }}</li>
          </ul>
        </div>
      </div>

      <div class="solid-btn">開始小測</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [
        '乘法（兩位乘以兩位）',
        '除法（兩位乘以兩位）',
        '倍數和因數',
        '公倍數',
      ]
    }
  }
}
</script>

<style scoped lang="scss">
.quiz-dialog {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .4);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9;

  .box {
    width: 600px;
    height: 400px;
    background-color: #ffefd4;
    border-radius: 20px;
    flex-wrap: wrap;
    align-content: space-around;
    padding: 20px 0;
    box-sizing: border-box;
    position: relative;
    padding: 20px;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;

    .close-btn {
      position: absolute;
      top: -19px;
      right: -17px;
      width: 35px;
      height: 37px;
      border-radius: 50px;
      background-color: #b5282c;
      cursor: pointer;

      &:before, &:after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        width: 65%;
        height: 4px;
        border-radius: 4px;
        background-color: #fff;
        transform: rotateZ(45deg);
      }

      &:after {
        transform: rotateZ(-45deg);
      }
      .shadow {
        position: absolute;
        width: 100%;
        height: 100%;
        border-radius: 50px;
        box-shadow: inset 0 -4px 0 0 #841515;
        transition: box-shadow .1s linear;
      }

      &:hover {
        // opacity: .7;
        .shadow {
          box-shadow: inset 0 -1px 0 0 #841515;
        }
      }
    }

    .topic {
      width: 100%;
      text-align: center;
      font-size: 24px;
      color: #b5282c;
      font-weight: 700;
      margin-bottom: 10px;
    }

    .area {
      flex: 1;
      width: 100%;
      border-radius: 15px;
      box-sizing: border-box;
      position: relative;
      padding: 10px;
      padding-top: 40px;
      display: flex;

      .title {
        font-weight: 700;
        font-size: 14px;
      }

      .list {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        padding-left: 20px;

        .single {
          width: 50%;
          margin-bottom: 15px;
          font-size: 15px;
        }
      }
    }
    .solid-btn {
      position: absolute;
      width: 160px;
      height: 40px;
      border-radius: 40px;
      background-color: #ffb842;
      color: #333;
      font-weight: 700;
      font-size: 16px;
      text-align: center;
      cursor: pointer;
      margin-left: 10px;
      line-height: 35px;
      bottom: -25px;
      left: 0;
      right: 0;
      margin: auto;

      &:before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border-radius: 40px;
        box-shadow: inset 0px -4px 1px 0 #c0811f;
      }

      &:hover {
        background-color: #f7be61;
      }
    }
  }
}
</style>